import { chainCommands } from 'prosemirror-commands';
import { nodeInputRule } from '../../../utils/inputrules';
import { withLogAction } from '../../../utils/keymap';
import { YfmCutSpecs } from './YfmCutSpecs';
import { createYfmCut, toYfmCut } from './actions/toYfmCut';
import { backToCutTitle, exitFromCutTitle, liftEmptyBlockFromCut, removeCut } from './commands';
import { cutType } from './const';
import { YfmCutTitleNodeView } from './nodeviews/yfm-cut-title';
import { cutActivePlugin } from './plugins/active';
import { cutAutoOpenPlugin } from './plugins/auto-open';
import './index.css';
const cutAction = 'toYfmCut';
export { CutNode, cutType, cutTitleType, cutContentType } from './YfmCutSpecs';
export const YfmCut = (builder, opts) => {
    builder.use(YfmCutSpecs, Object.assign(Object.assign({}, opts), { 
        // @ts-expect-error
        cutView: 
        // FIX: ignore mutation and don't rerender node when yfm.js open or close cut
        () => () => ({
            ignoreMutation(mutation) {
                return mutation instanceof MutationRecord && mutation.type === 'attributes';
            },
        }), cutTitleView: () => (node) => new YfmCutTitleNodeView(node) }));
    builder
        .addPlugin(cutActivePlugin)
        .addPlugin(cutAutoOpenPlugin)
        .addAction(cutAction, () => toYfmCut)
        .addKeymap(() => ({
        Backspace: chainCommands(backToCutTitle, removeCut),
        Enter: chainCommands(exitFromCutTitle, liftEmptyBlockFromCut),
    }))
        .addInputRules(({ schema }) => ({
        rules: [nodeInputRule(/(?:^)({% cut)\s$/, cutType(schema).createAndFill(), 1)],
    }));
    if (opts === null || opts === void 0 ? void 0 : opts.yfmCutKey) {
        const { yfmCutKey } = opts;
        builder.addKeymap(() => ({ [yfmCutKey]: withLogAction('yfm_cut', createYfmCut) }));
    }
};
